module.exports = __webpack_public_path__ + "img/archive.505d54fd.svg";